(function() {
  'use strict';
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-upsell-btn]');
    if (!btn) return;
    e.preventDefault();
    var lineKey = btn.dataset.lineKey, targetVariantId = btn.dataset.targetVariant, targetHandle = btn.dataset.targetHandle;
    var properties = {};
    try { properties = JSON.parse(btn.dataset.itemProperties || '{}'); } catch(err) {}
    if (btn.dataset.multiVariant === 'true') {
      var modal = document.querySelector('frame-option-selector-modal');
      if (modal) modal.open(targetHandle, lineKey, properties);
      return;
    }
    performUpsell(lineKey, targetVariantId, properties);
  });
  window.performUpsell = function(lineKey, newVariantId, properties) {
    var btn = document.querySelector('[data-upsell-btn][data-line-key="' + lineKey + '"]');
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.loadingText || 'Upgrading...'; }
    fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:lineKey,quantity:0}) })
    .then(function(r){ return r.json(); })
    .then(function(){ return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:parseInt(newVariantId),quantity:1,properties:properties}) }); })
    .then(function(r){ return r.json(); })
    .then(function(){ if (typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-upsell'}); })
    .catch(function(err){ console.error('Upsell failed:',err); if(btn){btn.disabled=false;btn.textContent=btn.dataset.originalText||'Upgrade';} });
  };
})();
